var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-uploader __flex __flex_wrap",style:(_vm.rootStyle)},[_c('div',{staticClass:"image-up-item __flex __flex_ac __flex_jc",on:{"click":_vm.handleSelectImage}},[_c('div',{staticClass:"__community_ico_add"})])])}
var staticRenderFns = []

export { render, staticRenderFns }